import { render, staticRenderFns } from "./CampaignGroups.vue?vue&type=template&id=4f632d70&scoped=true&"
import script from "./CampaignGroups.vue?vue&type=script&lang=js&"
export * from "./CampaignGroups.vue?vue&type=script&lang=js&"
import style0 from "./CampaignGroups.vue?vue&type=style&index=0&id=4f632d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f632d70",
  null
  
)

export default component.exports